import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchRedeemOrdersRequest,
  fetchRedeemOrdersSuccess,
  fetchRedeemOrdersFailure,
  createRedeemRequest,
  createRedeemSuccess,
  createRedeemFailure,
  fetchDiamondPointOrdersRequest,
  fetchDiamondPointOrdersSuccess,
  fetchDiamondPointOrdersFailure,
  verifyDiamondPointOrderRequest,
  verifyDiamondPointOrderSuccess,
  verifyDiamondPointOrderFailure,
  createReferralRedeemRequest,
  createReferralRedeemSuccess,
  createReferralRedeemFailure,
  fetchReferralOrdersRequest,
  fetchReferralOrdersSuccess,
  fetchReferralOrdersFailure,
  verifyReferralOrderRequest,
  verifyReferralOrderSuccess,
  verifyReferralOrderFailure,
  fetchBenefitsRequest,
  fetchBenefitsSuccess,
  fetchBenefitsFailure,
  fetchCustomerDiamondPointsRequest,
  fetchCustomerDiamondPointsSuccess,
  fetchCustomerDiamondPointsFailure,
} from "./RedeemOrdersSlice";
import { toast } from "react-toastify";

function* fetchRedeemOrdersSaga(action) {
  try {
    const { start = 0, limit = 5, search = "", startDate ="", endDate ="" } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/redeem/getRedeemOrders?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      ),
    );

    const resData = response.data;

    if (resData.success) {
      const ordersList = resData.data?.data || [];
      const total = resData.data?.total || 0;
      console.log("ordersList", ordersList);
      yield put(
        fetchRedeemOrdersSuccess({
          orders: ordersList,
          total,
          message: resData.message,
        }),
      );
    } else {
      yield put(fetchRedeemOrdersFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchRedeemOrdersFailure(error.message));
  }
}

function* createRedeemSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/redeem/createRedeem`,
        action.payload,
      ),
    );

    const resData = response.data;
    console.log("resData",resData)
    if (resData?.success === true) {
      yield put(createRedeemSuccess({ message: resData?.message }));
      yield toast.success(resData?.message);
      yield put(fetchRedeemOrdersRequest());
    } else {
      const errorMessage =
        resData?.errormsg || resData?.message || "Something went wrong";

      yield put(createRedeemFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.errormsg || error.message;
    yield put(createRedeemFailure(errorMessage));
  }
}

function* fetchDiamondPointOrdersSaga(action) {
  try {
    const { start = 0, limit = 5, search = "",startDate ="", endDate =""   } = action.payload || {};
    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/diamond-point/get-all-orders?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      ),
    );

    const resData = response.data;

    if (resData.success) {
      const ordersList = resData.data?.data || [];
      const total = resData.data?.total || 0;
      yield put(
        fetchDiamondPointOrdersSuccess({
          orders: ordersList,
          total,
          message: resData.message,
        }),
      );
    } else {
      yield put(fetchDiamondPointOrdersFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchDiamondPointOrdersFailure(error.message));
  }
}

function* verifyDiamondPointOrderSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/diamond-point/verify-order`,
        action.payload,
      ),
    );

    const resData = response.data;

    if (resData.success) {
      yield put(verifyDiamondPointOrderSuccess({ message: resData.message }));
      yield toast.success("Diamond Point Order verified successfully.");
      // refresh list after verify
      yield put(fetchDiamondPointOrdersRequest({}));
    } else {
      const errorMessage = resData.errormsg || resData.message;
      yield put(verifyDiamondPointOrderFailure(errorMessage));
      yield toast.error(errorMessage);
    }
  } catch (error) {
    yield put(verifyDiamondPointOrderFailure(error.message));
    yield toast.error(error.message);
  }
}

function* createReferralRedeemSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/referral/createReferralRedeemOrder`,
        action.payload,
      ),
    );

    const resData = response.data;
    console.log("resData", resData);
    if (resData.success) {
      yield put(
        createReferralRedeemSuccess({
          message: resData.message,
          data: resData.data,
        }),
      );
      console.log("resData?.message", resData?.message);
      toast.success(resData?.message);
    } else {
      const errorMessage = resData.errormsg || resData.message;
      console.log("errorMessage", errorMessage);
      yield put(createReferralRedeemFailure(errorMessage));
      toast.error(errorMessage);
    }
  } catch (error) {
    yield put(createReferralRedeemFailure(error.message));
    toast.error(error.message);
  }
}

function* fetchReferralOrdersSaga(action) {
  try {
    const { start = 0, limit = 10, search = "", startDate="", endDate="" } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/referral/get-all-referral-orders?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      ),
    );

    const resData = response.data;
    console.log("resData", resData);
    if (resData.success) {
      const ordersList = resData.data?.data || [];
      const total = resData.data?.total || 0;

      yield put(
        fetchReferralOrdersSuccess({
          orders: ordersList,
          total,
          message: resData.message,
        }),
      );
    } else {
      yield put(fetchReferralOrdersFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchReferralOrdersFailure(error.message));
  }
}

function* verifyReferralOrderSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/referral/verify-referral-order`,
        action.payload,
      ),
    );

    const resData = response.data;

    if (resData.success) {
      yield put(verifyReferralOrderSuccess({ message: resData.message }));
      toast.success("Referral order verified successfully.");

      yield put(fetchReferralOrdersRequest({}));
    } else {
      const errorMessage = resData.errormsg || resData.message;
      yield put(verifyReferralOrderFailure(errorMessage));
      toast.error(errorMessage);
    }
  } catch (error) {
    yield put(verifyReferralOrderFailure(error.message));
    toast.error(error.message);
  }
}

function* fetchBenefitsSaga(action) {
  try {
    const { start = 0, limit = 10, search = "" } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/referral/get-all-benefits?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}`,
      ),
    );

    const resData = response.data;

    if (resData.success) {
      const benefitsList = resData.data?.data || [];
      const total = resData.data?.total || 0;

      yield put(
        fetchBenefitsSuccess({
          benefits: benefitsList,
          total,
          message: resData.message,
        }),
      );
    } else {
      yield put(fetchBenefitsFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchBenefitsFailure(error.message));
  }
}

function* fetchCustomerDiamondPointsSaga(action) {
  try {
    const { start = 0, limit = 10, search = "" } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/diamond-point/customer-diamond-points?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}`,
      ),
    );

    const resData = response.data;

    if (resData.success) {
      const records = resData.data?.data || [];
      const total = resData.data?.total || 0;

      yield put(
        fetchCustomerDiamondPointsSuccess({
          records,
          total,
          message: resData.message,
        }),
      );
    } else {
      yield put(fetchCustomerDiamondPointsFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchCustomerDiamondPointsFailure(error.message));
  }
}

export function* watchRedeemOrdersSaga() {
  yield takeLatest(fetchRedeemOrdersRequest.type, fetchRedeemOrdersSaga);
  yield takeLatest(createRedeemRequest.type, createRedeemSaga);
  yield takeLatest(
    fetchDiamondPointOrdersRequest.type,
    fetchDiamondPointOrdersSaga,
  );
  yield takeLatest(
    verifyDiamondPointOrderRequest.type,
    verifyDiamondPointOrderSaga,
  );
  yield takeLatest(createReferralRedeemRequest.type, createReferralRedeemSaga);
  yield takeLatest(fetchReferralOrdersRequest.type, fetchReferralOrdersSaga);
  yield takeLatest(verifyReferralOrderRequest.type, verifyReferralOrderSaga);
  yield takeLatest(fetchBenefitsRequest.type, fetchBenefitsSaga);
  yield takeLatest(
    fetchCustomerDiamondPointsRequest.type,
    fetchCustomerDiamondPointsSaga,
  );
}
